"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transitions = void 0;
exports.transitions = {
    transition: {
        duration: '0.3s',
    },
};
//# sourceMappingURL=transitions.js.map